import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// mode: 'light' | 'dark' | 'system'
export const useThemeStore = create(
  persist(
    (set, get) => ({
      mode: 'system',
      setTheme: (mode) => set({ mode }),
      toggle: () => {
        const { mode } = get();
        if (mode === 'light') set({ mode: 'dark' });
        else if (mode === 'dark') set({ mode: 'light' });
        else {
          // when system → decide based on system and flip
          const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
          set({ mode: prefersDark ? 'light' : 'dark' });
        }
      },
    }),
    {
      name: 'theme-preference',
      version: 1,
      partialize: (state) => ({ mode: state.mode }),
    }
  )
);


